import { cpfIsValid, cnpjIsValid } from '../../helpers';

const getDefaultState = () => {
  return {
    host: '',
    idColaborador: 1,
    colaborador: '',
    validadeOrcamento: 30,
    incrementQtdeBy: 1,
    backupTimeInMinutes: 60,
    configuracoes: [
      { idConfig: 1, description: 'Permitir alterar tabela preço', value: false },
      { idConfig: 2, description: 'Salva orçamento automático', value: false },
      { idConfig: 3, description: 'Utiliza catálogo produto', value: false },
      { idConfig: 4, description: 'Realiza backup ao salvar', value: false },
    ],
    configLayout: [
      // { idConfig: 1, description: 'Cor de fundo ao ler código', value: false },
    ],
    rules: {
      required: value => !!value || 'Campo obrigatório',
      cep: value => value && value.length === 8 || 'CEP inválido',
      zeroOrGreater: value => value >= 0 || 'Valor inválido',
      greaterThanZero: value => value > 0 || 'Valor inválido',
      isCpfValid: value => cpfIsValid(value) || 'CPF inválido',
      isCnpjValid: value => cnpjIsValid(value) || 'CNPJ inválido',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'Formato do e-mail inválido';
      }
    }
  }
}

const state = getDefaultState();

const getters = {
  apiHost: state => state.host,
  idColaborador: state => state.idColaborador,
  colaborador: state => state.colaborador,
  validadeOrcamento: state => state.validadeOrcamento,
  incrementQtdeBy: state => state.incrementQtdeBy,
  backupTimeInMinutes: state => state.backupTimeInMinutes,
  configuracoes: state => state.configuracoes,
  permiteAlterarTabelaPreco: state => state.configuracoes.find(config => config.idConfig === 1).value,
  salvaOrcamentoAuto: state => state.configuracoes.find(config => config.idConfig === 2).value,
  utilizaCatalogoProduto: state => state.configuracoes.find(config => config.idConfig === 3).value,
  realizaBackupAoSalvar: state => state.configuracoes.find(config => config.idConfig === 4).value,
  rules: state => state.rules,
};

const actions = {
  setHost({ commit }, host) {
    commit('SET_HOST', host);
  },
  setIdColaborador({ commit }, idColaborador) {
    commit('SET_ID_COLABORADOR', idColaborador);
  },
  setColaborador({ commit }, colaborador) {
    commit('SET_COLABORADOR', colaborador);
  },
  setValidadeOrcamento({ commit }, validadeOrcamento) {
    commit('SET_VALIDADE_ORCAMENTO', validadeOrcamento);
  },
  setIncrementQtdeBy({ commit }, incrementQtdeBy) {
    commit('SET_INCREMENT_QTDE_BY', incrementQtdeBy);
  },
  setConfiguracoes({ commit }, configuracoes) {
    commit('SET_CONFIGURACOES', configuracoes);
  },
  loadConfiguracoes({ commit }) {
    commit('LOAD_CONFIGURACOES');
  },
  saveConfiguracoes({ commit }, obj) {
    commit('SAVE_CONFIGURACOES', obj);
  },
  setBackupTime({ commit }, backupTime) {
    commit('SET_BACKUP_TIME', backupTime);
  }
};

const mutations = {
  LOAD_CONFIGURACOES: state => {
    const configPedidos = localStorage.getItem('configPedidos');
    if (configPedidos) {
      const {
        host,
        idColaborador,
        colaborador,
        validadeOrcamento,
        incrementQtdeBy,
        backupTimeInMinutes,
        configuracoes = [],
        configLayout = []
      } = JSON.parse(configPedidos);

      state.host = host;
      state.idColaborador = idColaborador || 1;
      state.colaborador = colaborador || 'COLABORADOR';
      state.validadeOrcamento = validadeOrcamento || 30;
      state.incrementQtdeBy = Number(incrementQtdeBy) || 1;
      state.backupTimeInMinutes = Number(backupTimeInMinutes) || 60;
      state.configuracoes.forEach(configState => {
        const newConfig = configuracoes.find(config => config.idConfig === configState.idConfig);
        configState.value = newConfig && newConfig.value || false;
      });
      state.configLayout.forEach(configState => {
        const newConfigLayout = configLayout.find(config => config.idConfig === configState.idConfig);
        configState.value = newConfigLayout.value || false;
      });
    }
  },
  SAVE_CONFIGURACOES: (state, obj) => {
    state.host = obj.host;
    state.idColaborador = obj.idColaborador,
    state.colaborador = obj.colaborador,
    state.validadeOrcamento = obj.validadeOrcamento,
    state.incrementQtdeBy = obj.incrementQtdeBy,
    state.backupTimeInMinutes = obj.backupTimeInMinutes,
    state.configuracoes = obj.configuracoes,
    state.configLayout = obj.configLayout
    localStorage.setItem('configPedidos', JSON.stringify(obj));
  },
  SET_CONFIGURACOES: (state, configuracoes) => {
    state.configuracoes.forEach(configState => {
      const newConfig = configuracoes.find(config => config.idConfig === configState.idConfig);
      configState.value = newConfig.value || false;
    });
  },
  CLEAR_CONFIGURACOES_STATE: state => {
    Object.assign(state, getDefaultState()),
    localStorage.removeItem('configPedidos');
  },
  SET_HOST: (state, host) => state.host = host,
  SET_ID_COLABORADOR: (state, idColaborador) => state.idColaborador = idColaborador,
  SET_COLABORADOR: (state, colaborador) => state.colaborador = colaborador,
  SET_VALIDADE_ORCAMENTO: (state, validadeOrcamento) => state.validadeOrcamento = validadeOrcamento,
  SET_INCREMENT_QTDE_BY: (state, incrementQtdeBy) => state.incrementQtdeBy = incrementQtdeBy,
  SET_BACKUP_TIME: (state, backupTime) => state.backupTimeInMinutes = backupTime,
};

export default {
  state,
  getters,
  actions,
  mutations
}